import { render, staticRenderFns } from "./roleManage.vue?vue&type=template&id=332f57d0&scoped=true"
import script from "./roleManage.vue?vue&type=script&lang=js"
export * from "./roleManage.vue?vue&type=script&lang=js"
import style0 from "./roleManage.vue?vue&type=style&index=0&id=332f57d0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332f57d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('332f57d0')) {
      api.createRecord('332f57d0', component.options)
    } else {
      api.reload('332f57d0', component.options)
    }
    module.hot.accept("./roleManage.vue?vue&type=template&id=332f57d0&scoped=true", function () {
      api.rerender('332f57d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/roleManage.vue"
export default component.exports